module.exports = __webpack_public_path__ + "img/myposition_am_브루노 페르난데스.0c535d70.png";